<script>
  /**@type {string}*/
  export let title;
  /**@type {string}*/
  export let description;
  /**@type {string}*/
  export let image;
</script>

<div class="banner">
  <div class="grid-content">
    <div class="info-banner">
      <h1>{@html title}</h1>
      <p>{@html description}</p>
    </div>
    <div class="image">
      <img src={image} alt={title} />
    </div>
  </div>
</div>

<style>
  .banner {
    width: 100svw;
    height: 95svh;
    max-height: 920px;
    aspect-ratio: 3/1;
    color: var(--white);
    padding: 10svh 2rem 2rem 2rem;
    margin-bottom: 8rem;
    background-color: var(--orange);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .grid-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    justify-content: center;
    align-items: center;
    max-width: 160rem;
    margin: 0 auto;
    gap: 10rem;
  }
  .grid-content .info-banner {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
  .banner h1 {
    font-size: clamp(6rem, 7vmax, 12rem);
    font-family: sirenia;
    line-height: 1;
    text-transform: uppercase;
  }
  .banner p {
    max-width: 160rem;
    font-size: clamp(2rem, 2.8vmax, 3.2rem);
    line-height: 1;
  }
  .banner .image {
    width: 100%;
    aspect-ratio: 1.1/1;
  }
  .banner .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 2rem;
  }
  @media (max-width: 1024px) and (orientation: portrait) {
    .banner {
      height: 50svh;
      padding: 5% 2rem 0 2rem;
    }
    .grid-content {
      gap: 3rem;
    }
    .banner h1 {
      font-size: clamp(3rem, 6vmax, 6rem);
    }
    .banner p {
      font-size: clamp(1.8rem, 1.8vmax, 2.5rem);
    }
  }
  @media (max-width: 767px) {
    .banner {
      aspect-ratio: 1/1.6;
      height: auto;
      padding: 10svh 2rem 2rem 2rem;
    }
    .grid-content {
      grid-template-rows: 2.2fr 1fr;
      grid-template-columns: 1fr;
      justify-content: center;
      gap: 0;
    }
    .grid-content .image {
      grid-row: 1/2;
    }
  }
</style>
